export default __webpack_public_path__ + "static/media/Donate_Icon.9f7f39de.svg";